import { Box, Grid, Skeleton, Stack } from '@mui/material';

const LIST_ITEM_COUNT = 3;

/**
 * Loading skeleton for the connections manage view (list panel + detail panel).
 */
export function ConnectionsManageSkeleton() {
  return (
    <Box maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              borderRadius: 1,
              border: 1,
              borderColor: 'divider',
              bgcolor: 'background.paper',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              height: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
              }}
            >
              <Skeleton variant="rounded" width={140} height={20} />
              <Skeleton variant="rounded" width={96} height={32} />
            </Box>

            <Stack spacing={1.5}>
              {Array.from({ length: LIST_ITEM_COUNT }, (_, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 1.5,
                    borderRadius: 1,
                    border: 1,
                    borderColor: 'divider',
                  }}
                >
                  <Skeleton variant="circular" width={40} height={40} />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Skeleton variant="text" width="70%" sx={{ typography: 'subtitle2' }} />
                    <Skeleton variant="text" width="50%" sx={{ typography: 'body2' }} />
                  </Box>
                </Box>
              ))}
            </Stack>
          </Box>
        </Grid>

        <Grid item xs={12} md={8}>
          <Box
            sx={{
              p: 2,
              borderRadius: 1,
              border: 1,
              borderColor: 'divider',
              bgcolor: 'background.paper',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              height: '100%',
              minHeight: 280,
            }}
          >
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="rounded" width={180} height={28} />
              </Box>
              <Skeleton variant="text" width={220} sx={{ typography: 'body2', mt: 0.5 }} />
            </Box>

            <Box>
              <Skeleton variant="text" width={240} sx={{ typography: 'body2', mb: 1.25 }} />
              <Stack direction="row" flexWrap="wrap" useFlexGap spacing={1}>
                <Skeleton variant="rounded" width={88} height={32} sx={{ borderRadius: 4 }} />
                <Skeleton variant="rounded" width={72} height={32} sx={{ borderRadius: 4 }} />
                <Skeleton variant="rounded" width={96} height={32} sx={{ borderRadius: 4 }} />
              </Stack>
            </Box>

            <Box sx={{ mt: 'auto' }}>
              <Skeleton variant="rectangular" width="100%" height={1} sx={{ mb: 2 }} />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Skeleton variant="rounded" width={120} height={32} />
                <Skeleton variant="rounded" width={110} height={32} />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
